export default __webpack_public_path__ + "static/media/milanese.4ed94a3d.jpg";